import { LOADING } from '../../lib/copy';
import './loading.css';

/**
 * The one "this read has not come back yet" mark: a small turning ring beside
 * the word. It sits inside whatever line the caller already renders, so the
 * surrounding type and spacing are the caller's.
 *
 * In-page it fades in after a beat, so a read that lands quickly never flashes
 * it. The bare sign-in and bootstrap screens pass `immediate`: they swap one
 * loading screen for the next while the page settles, and a delay restarting
 * on each swap would blink the mark off and on.
 */
export function Loading({ immediate = false }: { immediate?: boolean }) {
  return (
    <span className={immediate ? 'loading immediate' : 'loading'}>
      <span className="spinner" />
      {LOADING}
    </span>
  );
}
